import { useQuery } from '@tanstack/react-query';

import { apiService } from '@/services/api-service';

export function useFeatureFlags() {
	const { data: flags, isLoading } = useQuery({
		queryKey: ['featureFlags', 'me'],
		queryFn: async (): Promise<Record<string, boolean>> => {
			return apiService.fetchApi('/me/feature-flags');
		},
		staleTime: 5 * 60 * 1000,
		gcTime: 10 * 60 * 1000,
	});

	const hasFlag = (name: string): boolean => {
		return !!(flags && flags[name]);
	};

	return {
		flags: flags || {},
		isLoading,
		hasFlag,
	};
}
